import { Avatar } from "@tellescope/design-system";
import { useSecureFileUrl, type TellescopeModelFromName } from "@tellescope/tanstack-query";
import { formatInitials } from "@tellescope/utils";

interface MessageSenderAvatarProps {
  user: TellescopeModelFromName<"users">;
  className?: string;
}

export const MessageSenderAvatar = ({ user, className }: MessageSenderAvatarProps) => {
  const avatarUrl = useSecureFileUrl(user.avatar);

  return (
    <Avatar className={className} src={avatarUrl} id={user.id}>
      {formatInitials(user)}
    </Avatar>
  );
};
